// extracted by mini-css-extract-plugin
export default {"notification-box":"style_notification-box__KyWim","toast-notification":"style_toast-notification__Nb2SD"};